var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          defaultOrderColumn: "created_date_formatted",
          defaultOrderDirection: "asc",
          route_name: "incident_form",
          css_formats: {
            validated_date_formatted: function(name, model) {
              if (name) {
                return "badge badge-glow badge-" + model.status_label_validated
              } else {
                return ""
              }
            }
          }
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function(actions) {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-row gap-2" },
                  [
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "incident_form.handling",
                          expression: "`incident_form.handling`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Tratar formulário",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Tratar formulário',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-success",
                      attrs: { icon: "CheckIcon" },
                      on: {
                        click: function($event) {
                          return _vm.handling(actions.row.id)
                        }
                      }
                    }),
                    _vm.enableEditForm(actions.row.status)
                      ? _c("feather-icon", {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: "request_form_incident.edit",
                              expression: "`request_form_incident.edit`"
                            },
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top",
                              value: {
                                content: "Editar formulário aberto",
                                delay: { show: 100, hide: 100 }
                              },
                              expression:
                                "{\n            content: 'Editar formulário aberto',\n            delay: { show: 100, hide: 100 }\n          }",
                              modifiers: { top: true }
                            }
                          ],
                          staticClass:
                            "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                          attrs: { icon: "EditIcon" },
                          on: {
                            click: function($event) {
                              return _vm.edit(actions.row.id)
                            }
                          }
                        })
                      : _vm._e(),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "incident_form.detail",
                          expression: "`incident_form.detail`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Detalhar formulário",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Detalhar formulário',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-primary",
                      attrs: { icon: "EyeIcon" },
                      on: {
                        click: function($event) {
                          return _vm.detail(actions.row.id)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }